import { LinearProgress } from '@mui/material';

export default function LoadingMessage() {
  return <LinearProgress />;
}
